import { GET_USER_GENERAL_SETTINGS, UPDATE_USER_GENERAL_SETTINGS, SET_PAGE_CAPTURE_LIMIT, SET_PAGE_VIEW } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getUserGeneralSettings = () => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
    const response = await window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}`, options)

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from supervisors')
    } else {
      const { data } = await response.json()
      const userSettings = {
        firstName: data.firstName,
        lastName: data.lastName,
        jobTitle: data.jobTitle,
        cellPhone: data.cellPhone,
        officePhone: data.officePhone,
        samePhone: data.samePhone,
        emailAddress: data.emailAddress,
        enableSMS: data.enableSMS,
        defaultPage: data.defaultPage,
        defaultReport: data.defaultReport,
        defaultView: data.defaultView,
        defaultCaptureCount: data.defaultCaptureCount,
        avatarKey: data.avatarKey,
        avatarPath: (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + '/' + data.avatarPath : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + '/' + data.avatarPath : data.avatarPath
      }
      dispatch({
        type: GET_USER_GENERAL_SETTINGS,
        payload: userSettings
      })
      dispatch({
        type: SET_PAGE_CAPTURE_LIMIT,
        payload: userSettings.defaultCaptureCount
      })
      dispatch({
        type: SET_PAGE_VIEW,
        payload: userSettings.defaultPage
      })
    }
  }
}

export const updateUserGeneralSettings = (settings, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth

    const body = {
      firstName: settings.firstName,
      lastName: settings.lastName,
      jobTitle: settings.jobTitle,
      cellPhone: settings.samePhone === 0 ? settings.cellPhone : settings.officePhone,
      officePhone: settings.officePhone,
      samePhone: settings.samePhone,
      // emailAddress: settings.emailAddress,
      enableSMS: settings.enableSMS,
      defaultPage: settings.defaultPage,
      defaultReport: settings.defaultReport,
      defaultView: settings.defaultView,
      defaultCaptureCount: settings.defaultCaptureCount,
      avatarKey: settings.avatarKey,
      avatarPath: settings.avatarPath
    }
    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}`, options))

    if (!response.status || response.status === 401) {
      log.warn('non 200 status code from supervisors')
      fireFailure()
    } else {
      const userSettings = { ...settings }
      fireSuccess()
      dispatch({
        type: UPDATE_USER_GENERAL_SETTINGS,
        payload: userSettings
      })
    }
  }
}

export const updateUserAvatar = (avatar, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, supervisorID, accountId } = getState().auth
    const accountID = accountId

    const body = { avatar }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/supervisors/${supervisorID}/avatar`, options))

    if (!response.status || response.status === 400 || response.status === 401 || response.status === 404 || response.status === 413 || response.status === 500) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}
